<div class="mat-dialog-custom new-post-container">
  <div class="title-container">
    <h1 class="title" i18n>New Post</h1>
    <button
      id="closeDialog"
      class="close button button-link"
      type="button"
      aria-label="close"
      mat-dialog-close="cancel"
      i18n-aria-label
    >
      <svg-icon src="/assets/icons/close.svg" alt="close" i18n-alt />
    </button>
  </div>

  <div class="body-container">
    <div class="side-navigation-container">
      <rdx-user-content-menu
        [showGeofences]="areGeofencesEnabled"
        [showRecentContent]="true"
        (tabSelected)="onTabSelected($event)"
      />
    </div>
    <div class="items-list-container">
      @if (isLoading) {
        <mat-progress-spinner mode="indeterminate" />
      } @else {
        @switch (currentTab) {
          @case (navigationTabs.recent) {
            @if (recent.length) {
              <rdx-user-content-select-list
                [userContentItems]="recent"
                [selectedUserContentItems]="selectedItems.userContentItems"
                (selectToggled)="onItemSelected($event)"
              />
            }
            @if (!recent || recent.length === 0) {
              <div class="no-items-container">
                <svg-icon src="/assets/icons/time.svg" alt="Recent items" i18n-alt />
                <span class="align-no-items-text" i18n>No recent items</span>
              </div>
            }
          }
          @case (navigationTabs.trackedRides) {
            @if (trackedRides.length) {
              <rdx-user-content-select-list
                [userContentItems]="trackedRides"
                [selectedUserContentItems]="selectedItems.trackedRides"
                (selectToggled)="onItemSelected($event)"
              />
            }
            @if (!trackedRides || trackedRides.length === 0) {
              <div class="no-items-container">
                <svg-icon src="/assets/icons/rides.svg" alt="Rides" i18n-alt />
                <span class="align-no-items-text" i18n>No rides</span>
              </div>
            }
          }
          @case (navigationTabs.waypoints) {
            @if (waypoints.length) {
              <rdx-user-content-select-list
                [userContentItems]="waypoints"
                [selectedUserContentItems]="selectedItems.waypoints"
                (selectToggled)="onItemSelected($event)"
              />
            }
            @if (!waypoints || waypoints.length === 0) {
              <div class="no-items-container">
                <svg-icon src="/assets/icons/waypoint.svg" alt="Places" i18n-alt />
                <span class="align-no-items-text" i18n>No places</span>
              </div>
            }
          }
          @case (navigationTabs.plannedRides) {
            @if (plannedRides.length) {
              <rdx-user-content-select-list
                [userContentItems]="plannedRides"
                [selectedUserContentItems]="selectedItems.plannedRides"
                (selectToggled)="onItemSelected($event)"
              />
            }
            @if (!plannedRides || plannedRides.length === 0) {
              <div class="no-items-container">
                <svg-icon src="/assets/icons/routes.svg" alt="Routes" i18n-alt />
                <span class="align-no-items-text" i18n>No routes</span>
              </div>
            }
          }
          @case (navigationTabs.geofences) {
            @if (geofences.length) {
              <rdx-user-content-select-list
                [userContentItems]="geofences"
                [selectedUserContentItems]="selectedItems.geofences"
                (selectToggled)="onItemSelected($event)"
              />
            }
            @if (!geofences || geofences.length === 0) {
              <div class="no-items-container">
                <svg-icon src="/assets/icons/geofence.svg" alt="Areas" i18n-alt />
                <span class="align-no-items-text" i18n>No areas</span>
              </div>
            }
          }
          @case (navigationTabs.collections) {
            @if (collections.length) {
              <rdx-user-content-select-list
                [userContentItems]="collections"
                [selectedUserContentItems]="selectedItems.collections"
                (selectToggled)="onItemSelected($event)"
              />
            }
            @if (!collections || collections.length === 0) {
              <div class="no-items-container">
                <svg-icon src="/assets/icons/collection.svg" alt="Collections" i18n-alt />
                <span class="align-no-items-text" i18n>No collections</span>
              </div>
            }
          }
        }
      }
    </div>
  </div>
  <div class="buttons-container">
    <div class="description" i18n>Choose a ride or place to create a community post</div>
    <button
      id="newPostNext"
      class="button primary-button"
      type="button"
      [disabled]="!hasSelectedItem"
      (click)="close()"
    >
      <span class="title" i18n>Next</span>
    </button>
  </div>
</div>
